<p-chart type="line" [data]="barData" [options]="barOptions" [style]="{'height': '50%'}"></p-chart>